import { BaseEntity } from "yt-ng-framework";
import { NgbDate } from "@ng-bootstrap/ng-bootstrap";

export class StanjePoValutama extends BaseEntity{
    constructor(){
        super();
    }

    Datum: NgbDate = null;
    RSD: number = null;
    EUR: number = null;
    USD: number = null;
    GBP: number = null;
    CAD: number = null;
    CHF: number = null;
    AUD: number = null;
    BAM: number = null;
    SEK: number = null;
    NOK: number = null;
    Ukupno: number = null;

    Deserialize(input:any){
        this.ID=input.ID;
        this.Datum=input.Datum;
        this.RSD=this.blankIfZero(input.RSD);
        this.EUR=this.blankIfZero(input.EUR);
        this.USD=this.blankIfZero(input.USD);
        this.GBP=this.blankIfZero(input.GBP);
        this.CAD=this.blankIfZero(input.CAD);
        this.CHF=this.blankIfZero(input.CHF);
        this.AUD=this.blankIfZero(input.AUD);
        this.BAM=this.blankIfZero(input.BAM);
        this.SEK=this.blankIfZero(input.SEK);
        this.NOK=this.blankIfZero(input.NOK);
        this.Ukupno = this.blankIfZero(input.Ukupno);

        return this;
    }

    Serialize(input: StanjePoValutama){
        return input;
    }

    blankIfZero(value){
        return value == 0 ? "" : value;
    }

}